/**
 * Fills the cart drawer's cross-sell with Shopify's related products.
 *
 * Related products only exist when Shopify renders a section through its recommendations endpoint. This element asks
 * that endpoint for the cart drawer section itself, so the cross-sell comes back in the drawer's own layout and
 * settings, and takes its place. When there is nothing to show it simply goes away, leaving no stray heading.
 */
import { fetchSectionElement } from 'theme';

if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.load();
      }

      async load() {
        const url = new URL(`${window.Shopify?.routes?.root || '/'}recommendations/products`, location.origin);
        url.search = new URLSearchParams({
          section_id: this.getAttribute('section'),
          product_id: this.getAttribute('product'),
          limit: this.getAttribute('limit'),
          intent: 'related',
        });

        const crossSell = await fetchSectionElement(url, '[data-cross-sell]');
        if (!this.isConnected) return;
        crossSell ? this.replaceWith(document.importNode(crossSell, true)) : this.remove();
      }
    }
  );
}
